import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Bell } from '@phosphor-icons/react';
import { fmtStamp } from '@/utils/dateFmt';

const API = process.env.REACT_APP_BACKEND_URL;

export const BackofficeBell = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  const load = useCallback(async () => {
    try { const { data } = await axios.get(`${API}/api/backoffice-notifications`); setItems(Array.isArray(data) ? data : []); } catch {}
  }, []);

  useEffect(() => {
    load();
    const tick = () => { if (!document.hidden) load(); };
    const t = setInterval(tick, 30000);
    document.addEventListener('visibilitychange', tick);
    window.addEventListener('focus', tick);
    return () => { clearInterval(t); document.removeEventListener('visibilitychange', tick); window.removeEventListener('focus', tick); };
  }, [load]);

  const unread = items.filter(n => n.read === false).length;

  const openNotif = async (n) => {
    setOpen(false);
    if (!n.read) {
      setItems(prev => prev.map(x => x.id === n.id ? { ...x, read: true } : x));
      await axios.put(`${API}/api/backoffice-notifications/${n.id}/read`).catch(() => {});
    }
    if (n.link) navigate(n.link);
  };
  const readAll = async () => {
    setItems(prev => prev.map(x => ({ ...x, read: true })));
    axios.put(`${API}/api/backoffice-notifications/read-all`).catch(() => {});
  };

  return (
    <div className="relative" data-testid="backoffice-bell-wrap">
      <button onClick={() => { setOpen(o => !o); if (!open) load(); }} className="relative p-2 rounded-full bg-white border border-brand-border hover:bg-brand-bg" data-testid="backoffice-bell" aria-label="Notificações">
        <Bell size={18} className="text-brand-green" weight={unread ? 'fill' : 'regular'} />
        {unread > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[9px] font-bold min-w-[16px] h-4 rounded-full flex items-center justify-center px-1" data-testid="backoffice-bell-badge">{unread > 99 ? '99+' : unread}</span>
        )}
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 mt-2 w-80 max-w-[85vw] bg-white border border-brand-border rounded-2xl shadow-xl z-50 overflow-hidden" data-testid="backoffice-bell-panel">
            <div className="flex items-center justify-between px-4 py-2.5 border-b border-brand-border">
              <p className="text-sm font-semibold text-brand-text">Notificações</p>
              {unread > 0 && <button onClick={readAll} className="text-[11px] text-brand-green underline" data-testid="backoffice-bell-read-all">Marcar tudo como lido</button>}
            </div>
            <div className="max-h-96 overflow-y-auto">
              {items.length === 0 && <p className="text-xs text-brand-muted p-4 text-center" data-testid="backoffice-bell-empty">Sem notificações.</p>}
              {items.map(n => (
                <button key={n.id} onClick={() => openNotif(n)} className={`w-full text-left px-4 py-2.5 border-b border-brand-border/60 last:border-b-0 hover:bg-brand-bg ${n.read ? '' : 'bg-brand-green/5'}`} data-testid={`backoffice-notif-${n.id}`}>
                  <p className={`text-xs ${n.read ? 'text-brand-muted' : 'text-brand-text font-medium'}`}>{n.text || n.title || n.type}</p>
                  {n.created_at && <p className="text-[10px] text-brand-placeholder mt-0.5">{fmtStamp(n.created_at)}</p>}
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
